/**
 * 라우트 접근 결정(순수 함수). 비동기 데이터 로딩(프로필/권한)은 router 에서 수행하고,
 * 이 함수는 적재된 상태를 바탕으로 다음 동작만 결정한다. (테스트 용이성)
 *
 * @param {Object} ctx
 * @param {string|undefined} ctx.pageKey   - 라우트 meta.pageKey (없으면 권한 게이트 없음)
 * @param {boolean} ctx.isPublic           - 라우트 meta.public (로그인 없이 접근 가능)
 * @param {boolean} ctx.hasToken           - 인증 토큰 존재 여부
 * @param {(key:string)=>boolean} ctx.canAccessPage - store getter
 * @param {string|undefined} ctx.fromName  - 출발 라우트 name (초기 진입 판별)
 * @returns {{type:'allow'} | {type:'redirect', to:string} | {type:'deny', to:(false|string)}}
 */
function decideNavigation({ pageKey, isPublic, hasToken, canAccessPage, fromName }) {
	// 공개 페이지(로그인/로그아웃/비밀번호 재설정) — meta.public 로 **명시**한 것만.
	// 종전에는 pageKey 가 없으면 공개로 간주해, 권한 키를 안 붙인 화면이
	// 인증 검사까지 건너뛰고 비로그인 상태로 렌더됐다(관리자 시험양식 빌더 등).
	if (isPublic) return { type: 'allow' }

	// 인증 필수
	if (!hasToken) return { type: 'redirect', to: '/login' }

	// pageKey 가 없으면 권한 게이트 없이 로그인만 요구
	if (!pageKey) return { type: 'allow' }

	// 페이지 접근 권한
	if (!canAccessPage(pageKey)) {
		// home 까지 막힌 경우 루프 방지: 로그아웃
		if (pageKey === 'home') return { type: 'redirect', to: '/logout' }
		// 그 외: 현재 위치 유지(false). 초기 직접진입(fromName 없음)이면 home 으로.
		return { type: 'deny', to: fromName ? false : '/' }
	}

	return { type: 'allow' }
}

module.exports = { decideNavigation }
